@charset "UTF-8";

/* app/js/src/components/clipping-studio/shared/publish-preview-card/clipping-studio-publish-preview-card.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: block;
  width: 100%;
  container-type: inline-size;
}
.publish-preview-card {
  width: 100%;
  min-height: 40cqw;
  height: auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.08);
  font-family: "Open Sans", sans-serif;
  overflow: hidden;
}
.publish-preview-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}
.publish-preview-card__identity {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.publish-preview-card__icon-wrap {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.publish-preview-card__icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.publish-preview-card__icon ::ng-deep svg {
  width: 20px;
  height: 20px;
  display: block;
}
.publish-preview-card__icon-wrap.platform--youtube {
  color: #ff0000;
}
.publish-preview-card__icon-wrap.platform--facebook {
  color: #1877f2;
}
.publish-preview-card__icon-wrap.platform--instagram {
  color: #e4405f;
}
.publish-preview-card__icon-wrap.platform--twitch {
  color: #9146ff;
}
.publish-preview-card__icon-wrap.platform--tiktok {
  color: rgba(0, 0, 0, 0.85);
}
.publish-preview-card__icon-wrap.platform--website {
  color: rgba(0, 0, 0, 0.54);
}
.publish-preview-card__name {
  font-size: 12px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.publish-preview-card__aspect {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.54);
  font-family: monospace;
}
.publish-preview-card__body {
  display: flex;
  gap: 10px;
  padding: 10px 12px 12px;
}
.publish-preview-card__cover-col {
  flex: 0 0 33.333%;
  max-width: 33.333%;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.publish-preview-card__cover {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  background: rgb(235, 240, 244);
  border: 1px solid rgba(0, 0, 0, 0.14);
  box-sizing: border-box;
}
.publish-preview-card__cover-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.publish-preview-card__cover-placeholder {
  width: 100%;
  height: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: rgb(235, 240, 244);
}
.publish-preview-card__cover-placeholder-icon {
  width: 28px;
  height: auto;
  display: block;
  opacity: 0.45;
}
.publish-preview-card__meta {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.publish-preview-card__title {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.35;
  word-break: break-word;
}
.publish-preview-card__setting-line {
  margin: 0;
  font-size: 10px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.54);
  line-height: 1.35;
  word-break: break-word;
}
/*# sourceMappingURL=clipping-studio-publish-preview-card.component.css.map */
